import list from './list';
import request from './request';
import generate from './generate';
import activate from './activate';
import skip from './skip';

const multiFactorAuthentication = {
  list,
  request,
  generate,
  activate,
  skip,
};

export default multiFactorAuthentication;
